import * as React from 'react';
import styled from 'styled-components';
import { Layout, Form, Button, Descriptions } from 'antd';

export const SpacedSpan = styled.span`
  margin-top: 20px;
  margin-bottom: 20px;
`;
